<template>
  <div class="wrapper bg-grey-lightest">
    <div class="main-content-wrap">
      <div class="main-content-pannel">
        <div
          class="option-wrap bg-grey-lightest grey-bg-option no-border"
          style="height: 100px"
        >
          <div class="options">
            <div class="breadcrumb">
              <a href="javascript:void(0);" @click="goBack"
                ><i class="material-icons align-middle">chevron_left</i>
                Projects</a
              >
            </div>
            <div class="content-title-wrap p-t-0">
              <div class="main-content-title">
                {{ project ? project.title : "" }}
              </div>
              <div class="main-content-menu">
                <button
                  class="btn primary"
                  href="javascript:void(0);"
                  @click="projectDetailPublic"
                  title="Public View"
                >
                  <i class="material-icons-outlined align-middle">public</i>
                  Public View
                </button>
                <button
                  class="btn primary"
                  href="javascript:void(0);"
                  @click="addRole()"
                  :class="{ active: editOpen == 1 }"
                  title="Add Project"
                >
                  <i class="material-icons-outlined align-middle">add</i>
                  Add Role
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="main-flex" v-if="project">
          <div class="main-flex-1">
            <div class="pannel-1">
              <div class="pannel-1-title">
                <h3>Task</h3>
                <div class="pannel-1-title-option">
                  <a class="btn" href="javascript:void(0);" @click="editProject"
                    >Edit</a
                  >
                </div>
              </div>
              <div class="pannel-1-body project-detail-task">
                <p class="preline" v-html="project.task" />
                <h6>
                  <i class="material-icons-outlined align-middle"
                    >account_balance</i
                  >Client Description:
                </h6>
                <p class="preline" v-html="project.client_description" />
              </div>
              <div v-if="project.roles && project.roles.length > 0">
                <div
                  v-for="(role, index) in project.roles"
                  :key="index"
                  class="relative"
                >
                  <div class="hr"></div>
                  <div class="pannel-1-title">
                    <a href="javascript:void(0)" @click="toApply(role.id)">
                      <h3 class="cursor-default">
                        {{ role.title }}
                      </h3>
                    </a>
                    <div class="pannel-1-title-option">
                      <a
                        class="btn"
                        href="javascript:void(0);"
                        @click="editRole(index)"
                        >Edit</a
                      >
                    </div>
                  </div>
                  <div class="pannel-1-body project-detail-task">
                    <p class="preline" v-html="role.requirements" />
                    <p class="inline">
                      <label
                        ><i class="material-icons align-middle">account_box</i
                        >Tech Level</label
                      >
                      <span class="tech_lvl_tag"
                        ><i class="material-icons align-middle">stream</i
                        >{{ role.tech_level }}</span
                      >
                    </p>
                    <p class="inline">
                      <label
                        ><i class="material-icons align-middle">east</i
                        >Engagement Length</label
                      >
                      {{ role.engagement }}
                    </p>
                    <p class="inline">
                      <label
                        ><i class="material-icons-outlined align-middle"
                          >logout</i
                        >Estimated Start</label
                      >
                      {{ role.estimated_start | dateformatFilter("D/M/YYYY") }}
                    </p>
                    <p
                      class="inline"
                      v-if="
                        (role.role_rate !== null &&
                          role.role_rate !== undefined) ||
                        (role.consultant_rate !== null &&
                          role.consultant_rate !== undefined)
                      "
                    >
                      <label
                        ><i class="material-icons align-middle">attach_money</i
                        >Rate</label
                      >
                      ${{
                        role.c_rate_type === "monthly"
                          ? `${role.role_rate}/month`
                          : role.role_rate
                          ? `${role.role_rate}/hour`
                          : `${role.consultant_rate}/hour`
                      }}
                    </p>
                    <p
                      class="inline"
                      v-if="
                        role.display_client_rate !== null &&
                        role.display_client_rate !== undefined
                      "
                    >
                      <label
                        ><i class="material-icons align-middle"
                          >monetization_on</i
                        >Client Rate</label
                      >
                      ${{ role.display_client_rate }}/{{
                        role.display_client_rate_type === "monthly"
                          ? "month"
                          : "hour"
                      }}
                    </p>
                    <p
                      class="inline"
                      v-if="
                        role.hours_per_week !== null &&
                        role.hours_per_week !== undefined
                      "
                    >
                      <label
                        ><i class="material-icons align-middle"
                          >perm_contact_calendar</i
                        >Hours Weekly</label
                      >
                      {{ role.hours_per_week ? role.hours_per_week : "" }}/week
                    </p>
                  </div>
                  <div class="deal-size">
                    <p class="font-color-light font-lg">
                      Deal Size<i class="material-icons align-middle"
                        >arrow_drop_down</i
                      >
                    </p>
                    <p
                      v-if="
                        (role.role_rate !== null &&
                          role.role_rate !== undefined) ||
                        (role.consultant_rate !== null &&
                          role.consultant_rate !== undefined) ||
                        (role.rate_type === 'monthly' && role.role_rate)
                      "
                      class="assuming"
                    >
                      <span
                        >${{
                          role.c_rate_type === "monthly"
                            ? role.role_rate
                            : Math.floor(
                                role.hours_per_week *
                                  (role.role_rate
                                    ? role.role_rate
                                    : role.consultant_rate) *
                                  4
                              )
                        }}</span
                      >
                      /{{ role.c_rate_type === "monthly" ? "month" : "hour" }}
                    </p>
                    <p
                      v-if="
                        (role.display_client_rate !== null &&
                          role.display_client_rate !== undefined) ||
                        (role.display_client_rate !== null &&
                          role.display_client_rate !== undefined) ||
                        (role.rate_type === 'monthly' && role.role_rate)
                      "
                      class="assuming"
                    >
                      <span
                        >${{
                          role.display_client_rate_type === "monthly"
                            ? role.display_client_rate
                            : Math.floor(
                                role.hours_per_week *
                                  role.display_client_rate *
                                  4
                              )
                        }}</span
                      >
                      /{{
                        role.display_client_rate_type === "monthly"
                          ? "month"
                          : "hour"
                      }}
                      (to client)
                    </p>
                    <p class="font-color-lighter font-sm line-height-20">
                      Assuming 4 weeks per month
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="main-flex-1">
            <div v-for="(role, index) in project.roles" :key="index">
              <div v-if="index !== 0" class="hr m-t-l m-b-l"></div>
              <div class="pannel-out-title">
                <h3>{{ role.title }}</h3>
                <div class="pannel-out-option">
                  <a
                    class="btn"
                    href="javascript:void(0);"
                    @click="addConsultant(role.id)"
                    >Add Consultant</a
                  >
                </div>
              </div>

              <div
                v-if="
                  showConsultants[role.id] &&
                  showConsultants[role.id].length > 0
                "
              >
                <div
                  class="pannel-1 pannel-1-padding relative action-wrapper"
                  v-for="(consultant, cIndex) in showConsultants[role.id]"
                  :key="cIndex"
                  :class="{ 'quote-wrapper': consultant.quote }"
                  @click="onConsultantClick(role.id, consultant.id)"
                >
                  <div class="pannel-1-title">
                    <div style="width: 100%">
                      <h3>
                        <div
                          class="use-wrapper"
                          @click="toResume(consultant.id, $event)"
                        >
                          <div class="avatar">
                            <span v-if="!consultant.photo_url">{{
                              (consultant.name
                                ? consultant.name
                                : consultant.email) | getFirstLetter
                            }}</span>
                            <img v-else :src="consultant.photo_url" alt />
                          </div>
                          <div class="user-name">{{ consultant.name }}</div>
                        </div>
                        <i
                          class="material-icons align-middle font-color-lighter"
                          v-if="
                            (consultant.client_confirm ||
                              consultant.reply === 'yes') &&
                            !(
                              consultant.client_confirm &&
                              consultant.reply === 'yes'
                            )
                          "
                          >check</i
                        >
                        <i
                          class="material-icons align-middle font-color-lighter"
                          v-if="
                            consultant.client_confirm &&
                            consultant.reply === 'yes'
                          "
                          >done_all</i
                        >
                        <i
                          class="material-icons align-middle font-color-green"
                          v-if="consultant.verified"
                          >verified</i
                        >
                        <div class="consultant-action-wrapper">
                          <i
                            class="
                              material-icons
                              align-middle
                              consultant-action-button
                            "
                            @click="
                              editConsultant(role.id, consultant.id, $event)
                            "
                            >create</i
                          >
                          <i
                            class="
                              material-icons
                              align-middle
                              consultant-action-button
                            "
                            @click="
                              deleteConsultant(role.id, consultant.id, $event)
                            "
                            >delete</i
                          >
                        </div>
                        <div class="pannel-1-title-option">
                          <span>{{
                            consultant.role_rate | currencyFilter("$", 2)
                          }}</span>
                          <span>{{
                            consultant.c_rate_type === "monthly"
                              ? "/month"
                              : "/hour"
                          }}</span>
                          <span v-if="consultant.role_rate_to_client"
                            >({{
                              consultant.role_rate_to_client
                                | currencyFilter("$", 2)
                            }}<span>{{
                              consultant.c_rate_type_to_client === "monthly"
                                ? "/month"
                                : "/hour"
                            }}</span
                            >)</span
                          >
                        </div>
                      </h3>
                    </div>
                  </div>
                  <div class="hr"></div>
                  <div>
                    <div class="pannel-1-body p-b-0">
                      <p>{{ consultant.bio }}</p>
                    </div>
                    <div class="pannel-1-body p-b-0">
                      <p v-if="consultant.submitted_reason" class="bold inter">
                        Submitted reason:
                      </p>
                      <p v-html="consultant.submitted_reason" />
                    </div>
                    <div v-if="consultant.reason" class="pannel-1-body p-b-0">
                      <p class="bold inter">Rejected reason:</p>
                      <p v-html="consultant.reason" />
                    </div>
                    <div class="pannel-1-footer">
                      <div>
                        <span class="tech_lvl_tag"
                          ><i class="material-icons align-middle">stream</i
                          >{{ consultant.tech_level }}</span
                        >
                      </div>
                      <div class="pannel-1-footer-option">
                        <RoleStatusSelector
                          :status="consultant.status"
                          :statusOptions="roleStatusOptions"
                          :roleId="role.id"
                          :consultantId="consultant.id"
                          @onUpdate="updateConsultantStatus"
                        />
                      </div>
                    </div>
                  </div>
                  <CheckinDetail
                    v-if="consultant.status === 'Current Contractor'"
                    :email="consultant.email"
                    :projectId="project.id"
                    :rate="
                      consultant.role_rate
                        ? consultant.role_rate
                        : consultant.rate
                    "
                    :rateToClient="consultant.role_rate_to_client"
                    :rateType="consultant.c_rate_type"
                    :rateTypeToClient="consultant.c_rate_type_to_client"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="edit-pannel">
      <edit-pannel v-model="editOpen" title>
        <ProjectPanel
          v-if="editOpen == 1"
          :propsData="project"
          :projectPhaseOptions="projectPhaseOptions"
          @closePanel="closeEditPannel"
        ></ProjectPanel>
        <RolePanel
          v-if="editOpen == 2"
          :propsData="project"
          :roleId="editRoleId"
          :techLevelOptions="techLevelOptions"
          :metroOptions="metroOptions"
          :techWorkTypeOptions="techWorkTypeOptions"
          @closePanel="closeEditPannel"
          @deleteRole="deleteRole"
        ></RolePanel>
        <ConsultantPanel
          v-if="editOpen == 3"
          :editId="project.id"
          :roleId="editConRoleId"
          :roleData="project.roles"
          :consultantOptions="consultantOptions"
          :selectedConsultants="project.selected_consultants"
          :consultantId="editConsultantId"
          :roleStatusOptions="roleStatusOptions"
          @closePanel="closeEditPannel"
        ></ConsultantPanel>
        <RejectPanel
          v-if="editOpen == 4"
          :reason="rejectedReason"
          @updateRejectedReason="updateRejectedReason"
        ></RejectPanel>
        <SubmitPanel
          v-if="editOpen == 5"
          :reason="submittedReason"
          @updateSubmittedReason="updateSubmittedReason"
        ></SubmitPanel>
      </edit-pannel>
    </transition>
  </div>
</template>

<script>
import { db } from "@/vendor/firebase";
import EditPannel from "@/components/EditPannel";
import OptionMenu from "@/components/OptionMenu";
import { dateformat, deleteConfirm } from "@/utils/utils";

import ProjectPanel from "./ProjectPanel";
import RolePanel from "./RolePanel";
import ConsultantPanel from "./ConsultantPanel";
import * as database from "@/vendor/database";
import RoleStatusSelector from "./RoleStatusSelector.vue";
import RejectPanel from "./RejectedPanel.vue";
import SubmitPanel from "./SubmittedPanel.vue";
import { httpGet } from "@/http/http";
import { setDoc } from "@/vendor/database";
import CheckinDetail from "./CheckinDetail.vue";

export default {
  props: ["editOpenTitle"],
  data() {
    return {
      project: null,
      editOpen: false,
      estimatedStart: null,
      consultants: null,
      consultantOptions: [],
      editRoleId: null,
      editConRoleId: null,
      editConsultantId: null,
      showConsultants: {},
      projectPhases: null,
      projectPhaseOptions: [],
      techLevels: null,
      techLevelOptions: [],
      metros: null,
      metroOptions: [],
      techWorkTypes: null,
      techWorkTypeOptions: [],
      roleStatuses: null,
      roleStatusOptions: [],
      rejectedRoleId: null,
      rejectedConsultantId: null,
      rejectedReason: "",
      submittedRoleId: null,
      submittedConsultantId: null,
      submittedReason: "",
    };
  },
  components: {
    EditPannel,
    OptionMenu,
    ProjectPanel,
    RolePanel,
    ConsultantPanel,
    RoleStatusSelector,
    RejectPanel,
    SubmitPanel,
    CheckinDetail,
  },
  watch: {
    editOpenTitle: function (val) {
      this.editOpen = val;
    },
    project: function () {
      this.estimatedStart = dateformat(
        this.project.estimated_start,
        "MM/DD/YYYY HH:mm A"
      );
      this.initShowConsultants();
    },
    consultants: function () {
      this.consultantOptions = this.consultants
        .map((item) => ({
          value: item.id,
          text: item.name,
        }))
        .filter((item) => item.text);
      this.initShowConsultants();
    },
    projectPhases: function () {
      this.projectPhaseOptions = this.projectPhases.map((item) => ({
        text: item.name,
        value: item.name,
      }));
    },
    techLevels: function () {
      const techLevels = JSON.parse(JSON.stringify(this.techLevels));
      this.techLevelOptions = techLevels
        .sort((a, b) => a.order - b.order)
        .map((item) => ({
          text: item.name,
          value: item.name,
        }));
    },
    metros: function () {
      this.metroOptions = this.metros.map((item) => ({
        text: item.name,
        value: item.name,
      }));
    },
    techWorkTypes: function () {
      const techWorkTypes = JSON.parse(JSON.stringify(this.techWorkTypes));
      this.techWorkTypeOptions = techWorkTypes.map((item) => ({
        text: item.name,
        value: item.name,
      }));
    },
    roleStatuses: function () {
      this.roleStatusOptions = this.roleStatuses.map((item) => ({
        text: item.name,
        value: item.name,
      }));
      this.initShowConsultants();
    },
  },
  beforeMount() {
    this.bindData();
  },
  methods: {
    goBack: function () {
      this.$router.push("/home/admin/project_admin");
      this.closeEditPannel();
    },
    bindData: function () {
      this.$bind("project", db.collection("gigs").doc(this.$route.params.id));
      this.$bind("consultants", db.collection("consultants"));
      this.$bind("projectPhases", db.collection("project_phases"));
      this.$bind("techLevels", db.collection("tech_levels"));
      this.$bind("metros", db.collection("metros"));
      this.$bind("techWorkTypes", db.collection("new_work_types"));
      this.$bind("roleStatuses", db.collection("role_statuses"));
    },
    sortRoleStatus: function (a, b) {
      if (a.status && b.status) {
        let aOrder = 0;
        let bOrder = 0;
        const statuses = JSON.parse(JSON.stringify(this.roleStatuses));
        statuses.forEach((item) => {
          if (item.name === a.status) {
            aOrder = item.order;
          }
          if (item.name === b.status) {
            bOrder = item.order;
          }
        });
        if (aOrder === bOrder && !!a.verified !== !!b.verified) {
          if (a.verified) return -1;
          if (b.verified) return 1;
          return 0;
        } else if (
          aOrder === bOrder &&
          !!(a.client_confirm && a.reply === "yes") !==
            !!(b.client_confirm && b.reply === "yes")
        ) {
          if (a.client_confirm && a.reply === "yes") return -1;
          if (b.client_confirm && b.reply === "yes") return 1;
          return 0;
        } else if (
          aOrder === bOrder &&
          !!(a.client_confirm || a.reply === "yes") !==
            !!(b.client_confirm || b.reply === "yes")
        ) {
          if (a.client_confirm || a.reply === "yes") return -1;
          if (b.client_confirm || b.reply === "yes") return 1;
          return 0;
        } else {
          return aOrder - bOrder;
        }
      } else if (a.status) {
        return -1;
      } else if (b.status) {
        return 1;
      } else {
        return 0;
      }
    },
    initShowConsultants() {
      if (this.project && this.consultants && this.roleStatuses) {
        this.showConsultants = {};
        const selectedConsultants = this.project.selected_consultants;
        if (selectedConsultants) {
          selectedConsultants.forEach((item) => {
            const roleId = item.role_id;
            const consultants = item.consultants;
            if (roleId && consultants) {
              const slectedConsultants = [];
              consultants.forEach((item) => {
                const consultant = this.consultants.find(
                  (c) => c.id === item.id
                );
                if (consultant) {
                  if (this.project.phase === "Operational") {
                    if (item.status === "Current Contractor") {
                      slectedConsultants.push({ ...consultant, ...item });
                    }
                  } else {
                    slectedConsultants.push({ ...consultant, ...item });
                  }
                }
              });
              slectedConsultants.sort(this.sortRoleStatus);
              this.showConsultants[roleId] = slectedConsultants;
            }
          });
        }
        if (this.project.roles && this.showConsultants) {
          this.project.roles.forEach((role) => {
            if (
              role.rate_to_client !== null &&
              role.rate_to_client !== undefined
            ) {
              role.display_client_rate = role.rate_to_client;
              role.display_client_rate_type = role.rate_type;
            }
            const sc = this.showConsultants[role.id];
            if (sc) {
              const checkedConsultant = sc.find(
                (cc) => cc.status === "Current Contractor"
              );
              if (checkedConsultant) {
                role.consultant_rate = checkedConsultant.rate;
                role.c_rate_type = checkedConsultant.c_rate_type;
                role.c_rate_type_to_client =
                  checkedConsultant.c_rate_type_to_client;
                role.role_rate = checkedConsultant.role_rate;
                role.role_rate_to_client =
                  checkedConsultant.role_rate_to_client;
                role.display_client_rate = null;
                if (
                  role.role_rate_to_client !== null &&
                  role.role_rate_to_client !== undefined
                ) {
                  role.display_client_rate = role.role_rate_to_client;
                  role.display_client_rate_type = role.c_rate_type_to_client;
                } else if (
                  role.rate_to_client !== null &&
                  role.rate_to_client !== undefined
                ) {
                  role.display_client_rate = role.rate_to_client;
                  role.display_client_rate_type = role.rate_type;
                } else if (
                  role.role_rate !== null &&
                  role.role_rate !== undefined
                ) {
                  role.display_client_rate = role.role_rate * 1.35;
                  role.display_client_rate_type = "hourly";
                } else if (
                  role.consultant_rate !== null &&
                  role.consultant_rate !== undefined
                ) {
                  role.display_client_rate = role.consultant_rate * 1.35;
                  role.display_client_rate_type = "hourly";
                }
              }
            }
          });
        }
      }
    },
    openEditPannel: function (action, title, isToggle) {
      if (this.editOpen && this.editOpen != action) {
        this.editOpen = action;
        this.emitEditPannel(title);
        return;
      }
      if (isToggle) {
        this.editOpen = this.editOpen ? false : action;
      } else {
        this.editOpen = action;
      }
      this.emitEditPannel(title);
    },
    closeEditPannel: function () {
      this.editOpen = false;
      this.emitEditPannel();
    },
    emitEditPannel: function (title) {
      const param = {
        title: title,
        editOpen: this.editOpen,
      };
      this.$emit("openEditPannelTitle", param);
    },
    editProject: function () {
      this.openEditPannel(1, "Edit Project", true);
    },
    addRole: function () {
      this.editRoleId = null;
      this.openEditPannel(2, "Add Role", true);
    },
    editRole: function (index) {
      this.editRoleId = index;
      this.openEditPannel(2, "Edit Role", true);
    },
    deleteRole: function (index) {
      if (this.project.roles[index]) {
        deleteConfirm(async () => {
          const newRoles = this.project.roles.filter(
            (item, id) => id !== index
          );
          try {
            const result = await database.updateDocById(
              "gigs",
              this.project.id,
              { roles: newRoles }
            );
            if (result.ok) {
              this.$toasted.global.toast_success({
                message: "success",
              });
              this.closeEditPannel();
            } else {
              this.$toasted.global.toast_error({ message: "error" });
            }
          } catch {
            this.$toasted.global.toast_error({ message: "error" });
          }
        });
      }
    },
    addConsultant: function (roleId) {
      this.editConRoleId = roleId;
      this.editConsultantId = null;
      this.openEditPannel(3, "Add Consultant", true);
    },
    editConsultant: function (roleId, consultantId, event) {
      event.stopPropagation();
      this.editConRoleId = roleId;
      this.editConsultantId = consultantId;
      this.openEditPannel(3, "Edit Consultant", true);
    },
    deleteConsultant: function (roleId, consultantId, event) {
      event.stopPropagation();
      deleteConfirm(async () => {
        const selectedConsultants = JSON.parse(
          JSON.stringify(this.project.selected_consultants)
        );
        selectedConsultants.forEach((item) => {
          if (item.role_id === roleId) {
            item.consultants = item.consultants.filter(
              (c) => c.id !== consultantId
            );
          }
        });

        const result = await database.updateDocById("gigs", this.project.id, {
          selected_consultants: selectedConsultants,
        });
        if (result.ok) {
          this.$toasted.global.toast_success({
            message: "delete success",
          });
        } else {
          this.$toasted.global.toast_error({ message: "delete error" });
        }
      });
    },
    checkConsultant: async function (roleId, consultantId, check, event) {
      event.stopPropagation();
      const selectedConsultants = JSON.parse(
        JSON.stringify(this.project.selected_consultants)
      );
      selectedConsultants.forEach((item) => {
        if (item.role_id === roleId) {
          item.consultants.forEach((c) => {
            if (c.id === consultantId) {
              c.checked = check;
            }
          });
        }
      });
      const result = await database.updateDocById("gigs", this.project.id, {
        selected_consultants: selectedConsultants,
      });
      if (!result.ok) {
        this.$toasted.global.toast_error({ message: "check error" });
      }
    },
    toResume: function (id, event) {
      event.stopPropagation();
      const routeData = this.$router.resolve({
        path: "/home/consultant/consultant_resume",
        query: { id },
      });
      window.open(routeData.href, "_blank");
    },
    toApply: function (id) {
      const routeData = this.$router.resolve({
        path: "/consultant_apply_new",
        query: { project: this.project.id, role: id },
      });
      window.open(routeData.href, "_blank");
    },
    onConsultantClick: async function (roleId, consultantId) {
      const selectedConsultants = JSON.parse(
        JSON.stringify(this.project.selected_consultants)
      );
      selectedConsultants.forEach((item) => {
        if (item.role_id === roleId) {
          item.consultants.forEach((c) => {
            if (c.id === consultantId) {
              c.quote = true;
            } else {
              c.quote = false;
            }
          });
        }
      });
      const result = await database.updateDocById("gigs", this.project.id, {
        selected_consultants: selectedConsultants,
      });
      if (!result.ok) {
        this.$toasted.global.toast_error({ message: "request error" });
      } else {
        setDoc("assigned_consultants", roleId, {
          consultant_id: consultantId,
          role_id: roleId,
          project_id: this.project.id,
        });
      }
    },
    projectDetailPublic: function () {
      const routeData = this.$router.resolve({
        path: "/project_detail_public/" + this.project.id + "/allinfo",
      });
      window.open(routeData.href, "_blank");
    },
    updateConsultantStatus: function (data) {
      const selectedConsultants = JSON.parse(
        JSON.stringify(this.project.selected_consultants)
      );
      if (data.status === "Current Contractor") {
        const s = selectedConsultants
          .find((item) => item.role_id === data.roleId)
          .consultants.find((item) => item.status === "Current Contractor");
        if (s) {
          s.status = "Rejected";
        }
      }
      selectedConsultants
        .find((item) => item.role_id === data.roleId)
        .consultants.find((item) => item.id === data.consultantId).status =
        data.status;
      database.updateDocById("gigs", this.project.id, {
        selected_consultants: selectedConsultants,
      });
      if (data.status === "Rejected") {
        this.rejectedRoleId = data.roleId;
        this.rejectedConsultantId = data.consultantId;
        this.rejectedReason = selectedConsultants
          .find((item) => item.role_id === data.roleId)
          .consultants.find((item) => item.id === data.consultantId).reason;
        this.openEditPannel(4, "Rejected Reason", false);
      }
      if (data.status === "Submitted") {
        this.submittedRoleId = data.roleId;
        this.submittedConsultantId = data.consultantId;
        this.submittedReason = selectedConsultants
          .find((item) => item.role_id === data.roleId)
          .consultants.find(
            (item) => item.id === data.consultantId
          ).submitted_reason;
        this.openEditPannel(5, "Submitted Reason", false);
      }
    },
    updateRejectedReason: function (data) {
      const selectedConsultants = JSON.parse(
        JSON.stringify(this.project.selected_consultants)
      );
      selectedConsultants
        .find((item) => item.role_id === this.rejectedRoleId)
        .consultants.find(
          (item) => item.id === this.rejectedConsultantId
        ).reason = data;
      database.updateDocById("gigs", this.project.id, {
        selected_consultants: selectedConsultants,
      });
      this.closeEditPannel();
    },
    updateSubmittedReason: function (data) {
      const selectedConsultants = JSON.parse(
        JSON.stringify(this.project.selected_consultants)
      );
      selectedConsultants
        .find((item) => item.role_id === this.submittedRoleId)
        .consultants.find(
          (item) => item.id === this.submittedConsultantId
        ).submitted_reason = data;
      database.updateDocById("gigs", this.project.id, {
        selected_consultants: selectedConsultants,
      });
      this.closeEditPannel();
      if (data && this.project.email && this.project.email_notification) {
        httpGet("send_project_submit_email", {
          id: this.project.id,
          content: data,
          consultant: this.submittedConsultantId,
        });
      }
    },
  },
};
</script>

<style scoped>
.wrapper {
  flex: 1;
  display: flex;
}
.relative {
  position: relative;
}
.no-hover > div:hover {
  background: #fff;
}
.mt {
  margin-top: 30px;
  margin-right: 10px;
}
.mt-5 {
  margin-top: 5px;
  margin-right: 5px;
}
.check-button {
  width: 30px;
  height: 30px;
  cursor: pointer;
  padding-top: 8px;
  font-weight: 900;
  color: #cccccc;
}
.preline {
  white-space: pre-line;
}
.name-wrapper {
  display: flex;
}
.ml {
  margin-left: 5px;
}
.cursor-pointer {
  cursor: pointer;
}
.files-wrapper {
  width: 100%;
  padding: 20px;
  border-top: 1px solid var(--border-grey-lightest);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.files-wrapper > label {
  font-family: avenir-next-block;
  font-size: 12px;
}
.files-wrapper > *:not(:first-child) {
  margin-top: 4px;
}
.verified-tag {
  position: absolute;
  top: 0;
  right: 0;
}
.verified-tag::before,
.verified-tag::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  border-color: transparent;
  border-style: solid;
}

.verified-tag::before {
  border-width: 16px;
  border-right-color: transparent;
  border-top-color: transparent;
}

.verified-tag::after {
  border-width: 16px;
  border-right-color: #437512;
  border-top-color: #437512;
}
.relative {
  position: relative;
}
.flex-wrapper {
  display: flex;
  align-items: center;
}
.consultant-action {
  display: none;
  position: absolute;
  right: 15px;
  top: 15px;
  font-size: var(--font-size-l);
}
.action-wrapper {
  cursor: pointer;
}
.action-wrapper:hover .consultant-action-wrapper {
  display: block;
}
.quote-wrapper {
  border: 2px solid #0085ff;
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.1), 0px 3px 3px rgba(0, 0, 0, 0.06),
    0px 3px 4px rgba(0, 0, 0, 0.08);
}
.use-wrapper {
  display: flex;
  align-items: center;
}
.user-name {
  color: var(--blue-light);
}
.user-name:hover {
  text-decoration: underline;
}
.consultant-action-wrapper {
  display: none;
}
.consultant-action-button {
  color: var(--font-color-lighter) !important;
  margin-right: 6px;
}
.consultant-action-button:hover {
  color: var(--font-color-light) !important;
}
</style>
